import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { Status } from "~/models/Status";

const paths = {
	index: "/vendors/statuses"
};
type TIndex = () => SwrReturnType<Status[]>;
type ReturnType = {
	index: TIndex;
};
export const useStatuses = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<Status[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
